import React, { Component } from "react";
import PropTypes from "prop-types";

import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { withTranslation, Trans } from "react-i18next";
import { withStyles } from "@material-ui/core/styles";
import { CUSTOM_SEARCH_BAR } from "./partials/constants";

const styles = (theme) => ({});

class EnhancedTableHead extends Component {
  static propTypes = {
    sortDirection: PropTypes.oneOf(["asc", "desc"]).isRequired,
    sortField: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      sortDirection: this.props.sortDirection,
      sortField: this.props.sortField,
      width: 0,
      height: 0,
      logged: this.props.logged,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (
      this.props.sortDirection !== prevProps.sortDirection ||
      this.props.sortField !== prevProps.sortField
    ) {
      this.setState({
        sortDirection: this.props.sortDirection,
        sortField: this.props.sortField,
      });
    }
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth, height: window.innerHeight });
  }

  render() {
    const { width, sortDirection, sortField, logged } = this.state;
    const { classes } = this.props;
    const { t } = this.props;
    const from = this.props?.from;
    const resultsFields = this.props?.resultsFields;

    const headCells1 = [
      {
        id: "fam",
        numeric: false,
        disablePadding: false,
        label: t("Fam."),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "img",
        numeric: false,
        disablePadding: false,
        label: t("Image"),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "product_img",
        numeric: false,
        disablePadding: true,
        label: "",
        mobileHide: false,
        deskHide: true,
      },
      {
        id: "id",
        numeric: false,
        disablePadding: false,
        label: t("Code"),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "manufacturer",
        numeric: false,
        disablePadding: false,
        label: t("Manufacturer"),
        mobileHide: false,
        deskHide: false,
      },
      {
        id: "reference",
        numeric: false,
        disablePadding: false,
        label: t("Reference"),
        mobileHide: false,
        deskHide: false,
      },
      {
        id: "description",
        numeric: false,
        disablePadding: false,
        label: t("Description"),
        mobileHide: false,
        deskHide: false,
      },
      {
        id: "pvp_neto",
        numeric: false,
        disablePadding: false,
        label: t("PVP / Net"),
        mobileHide: true,
        deskHide: true,
      },
      {
        id: "net_price",
        numeric: false,
        disablePadding: false,
        label: t("Net Price"),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "pvp",
        numeric: false,
        disablePadding: false,
        label: t("PVP"),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "stock",
        numeric: false,
        disablePadding: false,
        label: t("Stock"),
        mobileHide: true,
        deskHide: false,
      },
      /*{ id: 'comprar', numeric: false, disablePadding: false, label: t('To buy') },*/
    ];
    const headCells2 = [
      from &&
        resultsFields.includes("main_family") && {
          id: "fam",
          numeric: false,
          disablePadding: false,
          label: t("Fam."),
          mobileHide: false,
          deskHide: false,
        },
      from &&
        resultsFields.includes("image") && {
          id: "img",
          numeric: false,
          disablePadding: false,
          label: t(""),
          mobileHide: false,
          deskHide: false,
        },
      from &&
        resultsFields.includes("product_img") && {
          id: "product_img",
          numeric: false,
          disablePadding: true,
          label: "",
          mobileHide: true,
          deskHide: true,
        },
      from &&
        resultsFields.includes("code") && {
          id: "id",
          numeric: false,
          disablePadding: false,
          label: t("Code"),
          mobileHide: true,
          deskHide: false,
        },
      from &&
        resultsFields.includes("manufacturer") && {
          id: "manufacturer",
          numeric: false,
          disablePadding: false,
          label: t("Manufacturer"),
          mobileHide: false,
          deskHide: false,
        },
      from &&
        resultsFields.includes("reference") && {
          id: "reference",
          numeric: false,
          disablePadding: false,
          label: t("Reference"),
          mobileHide: false,
          deskHide: false,
        },
      from &&
        resultsFields.includes("name") && {
          id: "description",
          numeric: false,
          disablePadding: false,
          label: t("Description"),
          mobileHide: false,
          deskHide: false,
        },
      from &&
        resultsFields.includes("pvp_neto") && {
          id: "pvp_neto",
          numeric: false,
          disablePadding: false,
          label: t("PVP / Net"),
          mobileHide: true,
          deskHide: false,
        },
      from &&
        resultsFields.includes("net_price") && {
          id: "net_price",
          numeric: false,
          disablePadding: false,
          label: t("Net Price"),
          mobileHide: true,
          deskHide: false,
        },
      from &&
        resultsFields.includes("list_price") && {
          id: "pvp",
          numeric: false,
          disablePadding: false,
          label: t("PVP"),
          mobileHide: true,
          deskHide: false,
        },
      from &&
        resultsFields.includes("stock") && {
          id: "stock",
          numeric: false,
          disablePadding: false,
          label: t("Stock"),
          mobileHide: true,
          deskHide: false,
        },
      {
        id: "cart",
        numeric: false,
        disablePadding: false,
        label: t(""),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "select",
        numeric: false,
        disablePadding: false,
        label: t(""),
        mobileHide: true,
        deskHide: false,
      },
      {
        id: "icon",
        numeric: false,
        disablePadding: false,
        label: t(""),
        mobileHide: false,
        deskHide: true,
      },
    ];

    // custom or default header
    if (!from) {
      const headCells = headCells1;
      return (
        <TableHead>
          <TableRow>
            {headCells.map((headCell, index) => (
              <React.Fragment key={index}>
                {width <= 1500 && width >= 768 && index === 4 ? null : width <=
                    1280 &&
                  width >= 1025 &&
                  index === 8 ? null : (
                  // (width <= 767 && index === 6) ? (
                  //   null
                  // ) : (
                  // index === 9 && !logged ? (
                  //   null
                  // ) : (
                  <TableCell
                    key={headCell.id}
                    align={headCell.numeric ? "right" : "left"}
                    padding={headCell.disablePadding ? "none" : "normal"}
                    sortDirection={
                      sortField === headCell.id ? sortDirection : false
                    }
                    // className={headCell.deskHide ? `desk-hide thead-col${index}` : headCell.mobileHide ? `sm-hide thead-col${index}` : `thead-col${index}` }
                    className={`${
                      headCell.deskHide
                        ? "desk-hide"
                        : headCell.mobileHide
                        ? "sm-hide"
                        : ""
                    } thead-col${index}`}
                  >
                    <strong>{headCell.label}</strong>
                  </TableCell>
                  // )
                  // )
                )}
              </React.Fragment>
            ))}
          </TableRow>
        </TableHead>
      );
    } else {
      const headCells = headCells2.filter((el) => el);
      return (
        <TableHead>
          <TableRow>
            {headCells.map((headCell, index) => (
              <TableCell
                key={headCell.id}
                align={headCell.numeric ? "right" : "left"}
                padding={headCell.disablePadding ? "none" : "normal"}
                sortDirection={
                  sortField === headCell.id ? sortDirection : false
                }
                className={`${
                  headCell.deskHide
                    ? "desk-hide"
                    : headCell.mobileHide
                    ? "sm-hide"
                    : headCell.id === "manufacturer"
                    ? "ellipsis-col small"
                    : headCell.id === "reference"
                    ? "ellipsis-col small"
                    : headCell.id === "description"
                    ? "ellipsis-col large"
                    : ""
                } thead-col${index}`}
              ><strong>{headCell.label}</strong>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      );
    }
  }
}

export default withStyles(styles)(withTranslation()(EnhancedTableHead));
